import 'takeover/takeover.js';
import lazySizes from 'lazysizes';
import('../sbf-design-system/components/forms/email_suggest.js').then(({ default: initEmailFields }) => initEmailFields());

lazySizes.cfg.iframeLoadMode = 1;
